import _ from 'lodash';

/** Layout row id for manual grids — must match Mongo layout mapping `_id`. */
export const resolveManualLayoutMappingId = (item) =>
  _.get(item, 'id') || _.get(item, 'content.id') || null;
